export default "__VITE_ASSET__Dkr5y5y6__"